const CustomSurveyType = {
    Default : 0,
    EORTCQLQ_C30 : 1,
    EORTC_QLQ_BR23 : 2,
    EQ_5D : 3
}

export default CustomSurveyType;